import React from "react";
import { Mail, Bell, Search } from "lucide-react";
import { useEffect, useState, useRef } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

const DashboardHeader = () => {
  const [displayName, setDisplayName] = useState("Guest");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user?.displayName) {
        setDisplayName(user.displayName);
      } else if (user) {
        setDisplayName("User");
      } else {
        setDisplayName("Guest");
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("authToken");
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="flex gap-8 items-center justify-end w-full sticky z-50 top-0 py-4 bg-white">
      <div className="flex items-center gap-6 relative" ref={dropdownRef}>
        <button className="p-2 border border-black rounded-full cursor-pointer">
          <Bell className="w-6 h-6" />
        </button>
        <div>|</div>
        <div className="relative">
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <p>{displayName}</p>
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-4 w-48 bg-white border border-black rounded-md shadow-lg z-50">
              <button
                onClick={() => {
                  setDropdownOpen(false);
                  navigate("/profile");
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                View Profile
              </button>
              <button
                onClick={() => {
                  setDropdownOpen(false);
                  navigate("/change-password");
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Change Password
              </button>
              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
